// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"36a4a7f6","235":"3cdbd223","592":"550719b1","878":"1b460af7"}[chunkId] + ".css";
};